import { render, staticRenderFns } from "./ServiceReport.vue?vue&type=template&id=774579c6&scoped=true"
import script from "./ServiceReport.vue?vue&type=script&lang=js"
export * from "./ServiceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774579c6",
  null
  
)

export default component.exports